import { combineReducers } from 'redux'
import ApplicationRepository from './repositories/application.repository'
import ProjectRepository from './repositories/project.repository'
import SpinnerRepository from './repositories/spinner.repository'
import CheckStatusRepository from './repositories/check_rank.repository'


export default combineReducers({
    ApplicationRepository, ProjectRepository, SpinnerRepository, CheckStatusRepository
})